import {useEffect, useState} from 'react';
import {OrganizationState} from '~/redux/reducers/OrganizationReducer';
import {PingUser} from '../../../lib/auth/ping/types/PingUser';
import {initPendoWithUser} from '../../../lib/initPendo';

export const useUIWrapperPendoInit = (user: PingUser, organization: OrganizationState): void => {
    const [pendoInitialized, setPendoInitialized] = useState<boolean>(false);

    const orgEntityId = organization?.stores?.[0]?.parentId;

    useEffect(() => {
        if (!pendoInitialized && user && orgEntityId) {
            initPendoWithUser(user, orgEntityId);
            setPendoInitialized(true);
        }
    }, [user, orgEntityId, pendoInitialized]);
};
